export default {
  opened: (state) => state.app.slider.opened,
  token: (state) => state.app.token,
  uname: (state) => state.app.uname,
  menuList: (state) => state.app.menuList,
  permissionList: (state) => state.app.permissionList
}
